export default __webpack_public_path__ + "static/media/web3media.5ae8d973.png";